import React from "react";
import DocList from "../../_components/Sales/SalesDocList";
import { FiFileText, FiClock, FiCheckCircle, FiXCircle, FiUser, FiDollarSign, FiCreditCard, FiHome } from "react-icons/fi";
import { T, fmtMYR } from "../../_components/Sales/SalesShared";
import { getInvoices, getInvoiceKpis, deleteInvoice } from "../../_services/sales.service";

export default function Invoices() {
    return (
        <DocList
            docType="Invoice"
            basePath="/sales/invoices"
            fetchList={getInvoices}
            fetchKpis={getInvoiceKpis}
            deleteItem={deleteInvoice}
            statuses={["All", "Draft", "Pending for Approval", "Approved", "Rejected"]}
            kpiCards={[
                { label: "Total Invoices", key: "total", icon: FiFileText, color: T.accent },
                { label: "Pending", key: "pending", icon: FiClock, color: T.warning },
                { label: "Approved", key: "approved", icon: FiCheckCircle, color: T.success },
                { label: "Rejected", key: "rejected", icon: FiXCircle, color: T.danger },
            ]}
            previewFields={[
                { icon: FiClock, label: "Date", key: "date" },
                { icon: FiUser, label: "Contact Person", key: "contactPerson" },
                { icon: FiHome, label: "Company Name", key: "customer" },
                { icon: FiFileText, label: "SO Ref.", key: "soRef", render: (v, r) => r.soRef || r.so_ref || r.so_id || r.soReference || r.quotationRef || "—" },
                { icon: FiDollarSign, label: "Grand Total", key: "grandTotal", render: (v) => fmtMYR(v) },
                { icon: FiCreditCard, label: "Payment Terms", key: "paymentTerms" },
            ]}
            searchOptions={[
                { key: "all", label: "All" },
                { key: "id", label: "Invoice No." },
                { key: "date", label: "Date" },
                { key: "contactPerson", label: "Contact Person" },
                { key: "customer", label: "Company Name" },
                { key: "grandTotal", label: "Grand Total" },
            ]}
        />
    );
}